import Amplify, { Auth, Storage } from "aws-amplify";
import Joi from "joi-browser";
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { getSettings } from "store/settings";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import deleteIcon from "include/images/delete-icon.svg";
import plusIcon from "include/images/plus-1.svg";
import placeholderJson from "include/json/placeholder-img.json";
//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import Lottie from "react-lottie-player";
import { addSpinPack, updateSpinPack } from "store/telegram";
import { v4 as uuidv4 } from "uuid";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: "us-east-1",
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET,
    region: "us-east-1",
  },
});
Auth.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: "us-east-1", // REQUIRED - Amazon Cognito Region
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET, //REQUIRED -  Amazon S3 bucket
    region: "us-east-1",
  },
});
class AddFlyer extends Form {
  fileInputRef = React.createRef(null);
  state = {
    loading: false,
    data: {
      spins: "",
      price: "",
      discount: "",
      discountedPrice: "",
      image: null,
    },
    errors: {},
    loadingPackage: false,
    loadingImage: false,
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      this.clearData();
      if (this.props.showModal) {
        if (this.props.edit) {
          const data = { ...this.state.data };
          data.spins = this.props.edit.spins;
          data.price = this.props.edit.price;
          data.discount = this.props.edit.discount;
          data.discountedPrice = this.props.edit.discountedPrice;
          data.image = this.props.edit.image;
          this.setState({ data });
        }
      }
    }
  };
  handleImageChange = (e) => {
    const errors = { ...this.state.errors };
    this.setState({ loadingImage: true });
    const fSize = Math.round(e.target.files[0].size / 1048576);
    const fType = e.target.files[0].type;
    const ext = e.target.files[0].name.split(".").pop();
    if (fSize > 25) {
      toast(<AlertError message="Image size exceeds maximum allowable size. Maximum allowable size is 25MB." />, {
        containerId: 1,
      });
      return this.setState({ loadingImage: false });
    } else if (!["image/png", "image/jpeg", "image/jpg", "image/webp"].includes(fType)) {
      toast(
        <AlertError message="File is not of correct format and hence cannot be uploaded. Valid image formats are PNG, JPG, JPEG and WEBP." />,
        {
          containerId: 1,
        },
      );
      return this.setState({ loadingImage: false });
    } else {
      const fileName = uuidv4() + "." + ext;
      Storage.put(fileName, e.target.files[0], {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      }).then((result) => {
        this.setState({
          errors,
          loadingImage: false,
          data: {
            ...this.state.data,
            image: "public/" + result?.key,
          },
        });
      });
    }
    e.target.value = null;
  };
  doSubmit = (e) => {
    this.setState({ loadingPackage: true });
    const data = { ...this.state.data };
    const payLoad = {
      spins: parseInt(data.spins),
      price: parseFloat(data.price),
      discount: parseInt(data.discount),
      discountedPrice: parseFloat(data.discountedPrice),
      image: data?.image,
    };
    if (this.props.edit) {
      this.props.updateSpinPack(this.props.edit?._id, payLoad, (packagesResponse) => {
        this.setState({
          loadingPackage: false,
        });
        if (packagesResponse.status === 200) {
          toast(<AlertSuccess message="Information Saved" />, {
            containerId: 1,
          });
          this.clearData();
          this.props.toggleModal();
        } else {
          toast(<AlertError message={packagesResponse.data && packagesResponse.data.message} />, {
            containerId: 1,
          });
        }
      });
    } else {
      this.props.addSpinPack(payLoad, (packagesResponse) => {
        this.setState({
          loadingPackage: false,
        });
        if (packagesResponse.status === 200) {
          toast(<AlertSuccess message="Information Saved" />, {
            containerId: 1,
          });
          this.clearData();
          this.props.toggleModal();
        } else {
          toast(<AlertError message={packagesResponse.data && packagesResponse.data.message} />, {
            containerId: 1,
          });
        }
      });
    }
  };
  schema = {
    spins: Joi.alternatives().try(Joi.string(), Joi.number()).required(),
    price: Joi.alternatives().try(Joi.string(), Joi.number()).required(),
    discount: Joi.alternatives().try(Joi.string(), Joi.number()).required(),
    discountedPrice: Joi.alternatives().try(Joi.string(), Joi.number()).required(),
    image: Joi.string().required(),
  };
  clearData = () => {
    this.setState({
      loading: false,
      data: {
        spins: "",
        price: "",
        discount: "",
        discountedPrice: "",
        image: null,
      },
      errors: {},
      loadingPackage: false,
      loadingImage: false,
    });
  };
  render() {
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end custom-offcanvas-pannel "}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header>
          <h5>{this.props.edit ? (this.props.type === "contest" ? "" : "Edit ") : "Add "} Spin Pack</h5>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-check-outer">
            <div className="new-form-group">
              <div className="row">
                <div className="col-12 new-form-group">{this.renderInput("spins", "Spins", "", "")}</div>
              </div>{" "}
            </div>
            <div className="new-form-group">
              <div className="row">
                <div className="col-12 new-form-group">{this.renderInput("price", "Price", "", "number")}</div>
              </div>
            </div>{" "}
            <div className="new-form-group">
              <div className="row">
                <div className="col-6 new-form-group">{this.renderInput("discount", "Discount", "", "number")}</div>
                <div className="col-6 new-form-group">
                  {this.renderInput("discountedPrice", "Discounted Price", "", "number")}
                </div>
              </div>
            </div>{" "}
            <div className="new-form-group">
              <div className="kt-upload-row d-flex flex-wrap align-items-start">
                {!this.state.loadingImage ? (
                  <div
                    className={`kt-upload-outer ${
                      !this.state.data.image ? "placeholder-uploaded-img" : " position-relative"
                    } ${this.state.errors.image && "border-error"}`}
                  >
                    <div className={"kt-upload-img" + (this.state.data.image ? " bg-dark" : "")} htmlFor="uploadImg">
                      <img
                        src={this.state.data.image ? process.env.REACT_APP_CDN + this.state.data.image : plusIcon}
                        alt=""
                      />
                    </div>
                    <div
                      className="delete-icon d-flex align-items-center justify-content-center"
                      onClick={(e) => {
                        const data = this.state.data;
                        data.image = "";
                        this.setState({ data });
                      }}
                    >
                      <img src={deleteIcon} alt="delete" />
                    </div>
                  </div>
                ) : (
                  <div className="kt-upload-outer position-relative loading">
                    <div className="lottie-player-box">
                      <Lottie background="transparent" speed="1" loop autoplay animationData={placeholderJson} play />
                    </div>
                  </div>
                )}
                <div className="kt-file-input">
                  <label htmlFor="formFile" className="kt-label" id="uploadImg">
                    {this.state.data.image ? " Change Image" : "+ Upload Image"}
                  </label>{" "}
                  <input
                    className="form-control"
                    type="file"
                    id="formFile"
                    accept="image/*"
                    onChange={this.handleImageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loadingPackage}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  addSpinPack: (data, callback) => dispatch(addSpinPack(data, callback)),
  updateSpinPack: (id, data, callback) => dispatch(updateSpinPack(id, data, callback)),
});
const mapStateToProps = (state) => ({
  getSettings: getSettings(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFlyer));
